import { put } from 'redux-saga/effects'

import { startRefreshAlgoliaCache, stopRefreshAlgoliaCache } from './actions'

export function* ensureRefreshAlgoliaCache() {
  yield put(startRefreshAlgoliaCache())
  yield put(stopRefreshAlgoliaCache())
}
